import { MENU_CHANNELS, MENU_FULFILLMENT_TYPES, MENU_TYPES, } from '../constants.js';
import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
const getDefaultMenuType = () => 'olo';
export default new BaseMenuEntityConfiguration({
    consumable: false,
    filters: [
        {
            name: 'fulfillmentType',
            options: MENU_FULFILLMENT_TYPES,
            type: 'Select',
        },
        {
            name: 'type',
            options: MENU_TYPES,
            type: 'Select',
        },
        {
            name: 'allowInstructions',
            type: 'Boolean',
        },
        {
            name: 'channels',
            options: MENU_CHANNELS,
            type: 'Select',
        },
    ],
    hasDescription: false,
    hasHours: true,
    hasImage: false,
    hasVariations: false,
    hasPos: true,
    hasPresentation: true,
    lists: [
        {
            collection: 'Category',
            name: 'categories',
            primaryRelationship: true,
        },
    ],
    name: 'Menu',
    options: {
        type: getDefaultMenuType(),
        allowInstructions: false,
        showNutritionalInformation: true,
        channels: ['pos', 'online'],
        fulfillmentTypes: [],
        lastContentChangeAt: undefined,
        lastSyncedAt: undefined,
        sourceUrl: undefined,
        source: undefined,
        reviewed: undefined,
    },
    pluralizedName: 'Menus',
    sellable: false,
    sortKeys: [],
    unlinkedOptions: [],
    version: 11,
});
//# sourceMappingURL=menu.js.map